export default "__VITE_ASSET__CXN2zvLN__"